import { styled } from '@mui/material'

export const ProportionalToAttributesContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))
